/**
 * 
 * @param {RouteDetails} title 
 */
export function setPage(title) {
    document.title = title;
}